import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, Menu, Segment } from "semantic-ui-react";
import { closeModal } from "../actions";
import Template from "../admin/retailers/template";
import Standard from "../admin/retailers/standard";
import Settings from "../admin/retailers/settings";

const TemplateModal = (props) => {
  const dispatch = useDispatch();
  const { retailer, data, index, service } = props;

  const [activeItem, setActiveItem] = useState("tab1");

  const handleMenu = (item) => {
    setActiveItem(item);
  };
  return (
    <Modal
      closeIcon="close"
      open={true}
      onClose={() => dispatch(closeModal())}
      centered={props.centered}
    >
      <Modal.Content>
        <Menu attached="top" tabular>
          <Menu.Item
            name="Fields"
            active={activeItem === "tab1"}
            onClick={() => handleMenu("tab1")}
          />
          <Menu.Item
            name="Other settings"
            active={activeItem === "tab2"}
            onClick={() => handleMenu("tab2")}
          />
        </Menu>
        <Segment attached="bottom">
          {activeItem === "tab1" ? (
            retailer.templates[index].type === "native" ||
            retailer.templates[index].type === "custom" ||
            retailer.templates[index].type === "hybrid" ? (
              <Template
                retailer={retailer}
                data={data}
                id={index}
                service={service}
              />
            ) : (
              <Standard retailer={retailer} id={index} service={service} />
            )
          ) : (
            <Settings
              retailer={retailer}
              id={index}
              service={service}
              data={data}
            />
          )}
        </Segment>
      </Modal.Content>
    </Modal>
  );
};

export default TemplateModal;
